import { products, categories } from "../../data/products";

const HERO_BG =
  "https://images.unsplash.com/photo-1525947088131-b701cd0f6dc3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxkYXJrJTIwd29vZCUyMHRleHR1cmV8ZW58MHx8fHwxNzc4NjA5NDMxfDA&ixlib=rb-4.1.0&q=85";

export const Hero = () => {
  const productCount = products.length;
  const categoryCount = categories.length - 1; // exclude "Toate"
  const scrollTo = (sel) => {
    const el = document.querySelector(sel);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-[78vh] w-full flex items-end overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_BG})` }}
        aria-hidden
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#080706]/45 via-[#080706]/65 to-[#080706]" aria-hidden />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(200,169,126,0.16),transparent_60%)]" aria-hidden />

      <div className="relative max-w-7xl w-full mx-auto px-6 sm:px-12 pb-16 pt-32">
        <div className="max-w-3xl">
          <p className="text-xs font-semibold tracking-[0.32em] uppercase text-[#C8A97E] mb-8">
            — Distribuitor Premium · România
          </p>
          <h1 className="font-[Playfair_Display] text-[#FDF8F5] text-5xl sm:text-6xl lg:text-7xl font-medium leading-[1.05] tracking-tight">
            Calitate <em className="text-[#C8A97E] italic font-normal">Superioară.</em>
            <br />
            Cantități <span className="italic font-normal">En-Gross.</span>
          </h1>
          <p className="mt-8 text-[#A8A29E] text-base sm:text-lg font-light leading-relaxed max-w-xl">
            Aprovizionăm afacerea ta cu cele mai bune produse alimentare —
            de la vinuri fine la dulciuri artizanale, marinate, conserve și
            biscuiți de calitate, livrate la prețuri de producător.
          </p>

          <div className="mt-12 flex flex-wrap items-center gap-4">
            <button
              data-testid="hero-cta-catalog"
              onClick={() => scrollTo("#catalog")}
              className="bg-[#C8A97E] text-[#080706] px-8 py-4 text-sm font-medium tracking-wide hover:bg-[#B3956D] transition-colors duration-300"
            >
              Vezi Catalogul
            </button>
            <button
              data-testid="hero-cta-quote"
              onClick={() => scrollTo("#contact")}
              className="border border-[#3D3530] text-[#FDF8F5] bg-transparent px-8 py-4 text-sm font-medium tracking-wide hover:bg-[#0F0D0B] hover:border-[#C8A97E] transition-all duration-300"
            >
              Cere Ofertă
            </button>
          </div>

          <div className="mt-12 flex flex-wrap gap-x-14 gap-y-6 border-t border-[#1F1A18] pt-8">
            {[
              { n: `${productCount}+`, l: "Produse în catalog" },
              { n: `${categoryCount}+`, l: "Categorii distincte" },
              { n: "B2B", l: "Restaurante · Hoteluri · Retail" },
            ].map((s) => (
              <div key={s.l}>
                <div className="font-[Playfair_Display] text-3xl text-[#FDF8F5]">{s.n}</div>
                <div className="text-xs uppercase tracking-[0.2em] text-[#A8A29E] mt-1">{s.l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
